<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('otherPage.p1')}}</el-breadcrumb-item>
        <el-breadcrumb-item @click.native="toUrl(firstNav.url)">{{firstNav.title}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('otherPage.p9')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap clearfix">
        <div class="main">
          <div class="h2">{{dataObj.title}}</div>
          <div class="time"><i class="el-icon-time"></i> <span>{{dataObj.date}}</span></div>
          <div class="other">
            <div style="width: 650px; overflow: hidden; margin-right: 30px;">
              <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff;height: 463px;" class="swiper mySwiper2">
                <div class="swiper-wrapper">
                  <a :href="item" target="_blank" class="swiper-slide" v-for="(item,index) in dataObj.picUrlArr" :key="index">
                    <img :src="item" />
                  </a>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
              </div>
              <div thumbsSlider="" class="swiper mySwiper" style="height: 149px;padding-bottom: 0;" >
                <div class="swiper-wrapper">
                  <a :href="item" target="_blank" class="swiper-slide" v-for="(item,index) in dataObj.picUrlArr" :key="index">
                    <img :src="item" />
                  </a>
                </div>
              </div>

            </div>
            <div class="other-r" style="width: 750px;">
              <div class="item"><span>{{$t('otherPage.p16')}}</span>{{dataObj.address}}</div>
              <div class="item"><span>{{$t('otherPage.p17')}}</span>{{dataObj.classify}}</div>
              <div class="item"><span>{{$t('otherPage.p18')}}</span>{{dataObj.age}}</div>
              <!--<div class="item"><span>尺寸</span>{{dataObj.size}}</div>-->
              <div class="item"><span>{{$t('otherPage.p19')}}</span><div class="html" v-html="dataObj.detail"></div></div>
              <!-- JiaThis Button BEGIN -->
              <div class="item">
                <span>{{$t('otherPage.p11')}}</span>
                <SocialShare v-if="setTimeShare" :config="config"></SocialShare>
              </div>
              <!-- JiaThis Button END -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getShowGoods} from '@/api'
  // import {getCollectionA1Detail} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import {mixin} from '@/mixin/index.js';

  //引入Swiper
  import Swiper from "swiper";

  import SocialShare from 'vue-social-share';
  import 'vue-social-share/dist/client.css'
  import 'vue-social-share/dist/vue-social-share.js'

  export default {
    name: "Detail",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      SocialShare
    },
    data(){
      return{
        // 详情数据
        dataObj : {},
        // 延时显示分享
        setTimeShare: false,
        // 分享的配置
        config: {
          // // url: "", // 网址，默认使用 window.location.href
          // source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
          // title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          // description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          // image: "", // 图片, 默认取网页中第一个img标签
          // sites: [
          //   "qzone",
          //   "qq",
          //   "weibo",
          //   "wechat",
          //   "douban",
          //   "tencent",
          //   "linkedin",
          //   "google",
          //   "facebook",
          //   "twitter",
          // ], // 启用的站点
          // // disabled: ["google", "facebook", "twitter"], // 禁用的站
          sites: ['weibo', 'qq', 'wechat', 'douban', 'qzone'],
          wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
        },
        // 一级Nav
        firstNav: {},
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        // 更新静态数据(后退)
        this.$router.go(-1);
      }
    },
    created(){
      // 获取数据
      this.toGetData()
      // 延时显示分享
      setTimeout(() => {
        this.setTimeShare = true
      }, 100)
      // 获取详情对应的一级导航
      if(this.$store.getters.lang =='zh'){
        this.$store.getters.menu.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }else{
        this.$store.getters.menuEn.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }
    },
    methods:{
      // 获取数据
      async toGetData() {
        let {data:{data}} = await getShowGoods({
          id : this.$route.params.id,
        })

        if(!data){
          this.$router.push('/404');
        }

        let picUrlArr = data.goodsFacethum.split(',')
        picUrlArr.forEach((val,index)=>{
          picUrlArr[index] = this.$store.getters.urlApi + val
        })

        this.dataObj = {
          id : data.id,
          date : this.parseTime(new Date(data.updateTime),'{y}-{m}-{d} {h}:{m}'),
          title : this.$store.getters.lang == 'en' ? data.goodsTitleEn: data.goodsTitle,
          picUrl : this.$store.getters.urlApi + data.goodsFace,
          picUrlArr,
          address : this.$store.getters.lang == 'en' ? data.goodsAddressEn : data.goodsAddress,
          classify : this.$store.getters.lang == 'en' ? data.goodsTypeEn : data.goodsType,
          age : this.$store.getters.lang == 'en' ? data.goodsClassEn : data.goodsClass,
          size : this.$store.getters.lang == 'en' ? data.goodsSizeEn : data.goodsSize,
          detail : this.$store.getters.lang == 'en' ? this.updateImageUrl(data.goodsContentEn) : this.updateImageUrl(data.goodsContent)
        }
        this.$nextTick(()=>{
          var swiper = new Swiper(".mySwiper", {
            // loop: true,
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
          });
          new Swiper(".mySwiper2", {
            loop: true,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            thumbs: {
              swiper: swiper,
            },
          });
        })
      },
      // toGetData() {
      //   getCollectionA1Detail({id:this.$route.params.id}).then((res) => {
      //     this.dataObj = res.data.data
      //     this.$nextTick(()=>{
      //       var swiper = new Swiper(".mySwiper", {
      //         // loop: true,
      //         spaceBetween: 10,
      //         slidesPerView: 3,
      //         freeMode: true,
      //         watchSlidesProgress: true,
      //       });
      //       new Swiper(".mySwiper2", {
      //         loop: true,
      //         spaceBetween: 10,
      //         navigation: {
      //           nextEl: ".swiper-button-next",
      //           prevEl: ".swiper-button-prev",
      //         },
      //         thumbs: {
      //           swiper: swiper,
      //         },
      //       });
      //     })
      //
      //   })
      // },
    }
  }
</script>

<style scoped lang="less">
  .Breadcrumb {
    width: 1380px;
    margin: 0 auto;
    overflow: hidden;
    padding-top: 40px;
    padding-bottom: 60px;
  }
  .el-breadcrumb {
    font-size: 20px;
  }
  .el-breadcrumb__item{
    cursor: pointer;
  }

  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }

  .wrap{
    width: 1380px;
    margin: 0 auto;
    height: 100%;
  }
  /**/
  .container .main {
    line-height: 2;
    font-size: 16px;
    text-align: justify;
  }

  .container .main .h2 {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    line-height: 1;
  }

  .container .main .other {
    display: flex;
    width: 1380px;
    margin: 0 auto 140px;
  }

  .container .main .other img {
    cursor: pointer;
  }

  .container .main .other .other-r .item {
    display: flex;
    line-height: 40px;
    font-size: 18px;
    color: #666;
  }

  .container .main .other .other-r .item + .item {
    margin-top: 16px;
  }
  /*/deep/ .container .main .other .other-r .item .html p{*/
    /*margin-bottom: 10px;*/
  /*}*/
  .container .main .other .other-r .item span {
    background: #eeeeee;
    display: block;
    height: 40px;
    color: #747474;
    line-height: 40px;
    padding: 0 16px;
    font-size: 18px;
    margin-right: 18px;
    min-width: 110px;
    text-align: right;
  }
  .container .main .time{
    text-align: center;
    padding: 0 0 24px 0;
    font-size: 16px;
    color: #999;
    margin-top: 18px;
  }


  /**/
  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .swiper {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .mySwiper2 {
    height: 80%;
    width: 100%;
    position: relative;
  }

  .mySwiper {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .mySwiper .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .mySwiper .swiper-slide-thumb-active {
    opacity: 1;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /**/
</style>



// WEBPACK FOOTER //
// src/components/Collection/A1/Detail.vue